const CHHelp = () => {
	return (
		<>
			<path
				d="M17.27 25.01C8.68 27.05 3.58 22.15 7.83 17.56C14.17 10.72 37.77 20.15 17.27 25.01Z"
				fill="#F7D9D8"
			/>
			<path
				d="M16 29C8.83 29 3 23.17 3 16C3 8.83 8.83 3 16 3C23.17 3 29 8.83 29 16C29 23.17 23.17 29 16 29ZM16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4Z"
				fill="#C68486"
			/>
			<path
				d="M15.57 19.85C14.77 19.85 14.12 20.52 14.12 21.32C14.12 22.12 14.75 22.79 15.57 22.79C16.39 22.79 17.04 22.1 17.04 21.32C17.04 20.54 16.37 19.85 15.57 19.85Z"
				fill="#C68486"
			/>
			<path
				d="M15.82 8.71002C13.24 8.71002 12.05 10.24 12.05 11.27C12.05 12.02 12.68 12.36 13.2 12.36C14.23 12.36 13.81 10.89 15.76 10.89C16.72 10.89 17.48 11.31 17.48 12.19C17.48 13.22 16.41 13.82 15.78 14.35C15.23 14.83 14.5 15.61 14.5 17.26C14.5 18.25 14.77 18.54 15.55 18.54C16.49 18.54 16.68 18.12 16.68 17.76C16.68 16.77 16.7 16.19 17.75 15.37C18.27 14.97 19.89 13.67 19.89 11.87C19.89 10.07 18.26 8.71002 15.82 8.71002Z"
				fill="#C68486"
			/>
		</>
	);
};

export default CHHelp;
